
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-bf3d33e8&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./tag.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./tag.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-bf3d33e8!../node_modules/vue-loader/lib/selector?type=template&index=0!./tag.vue"),
  /* scopeId */
  "data-v-bf3d33e8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/tag.vue
// module id = 11
// module chunks = 0